import { useRecoilTransaction_UNSTABLE } from "recoil"

import { designLocalState } from "~/containers/Proposal/state/designs/design-state"

import type { TransactionOperation } from "."
import { findAzimuth } from "./findAzimuth"
import { getAreaIdsOfEdge } from "./getAreasIdsOfEdge"
import { edgeDesignationState } from "../../tool/edgeDesignation"
import { findEdgeState } from "../edges"
import type { EdgeActionTo_, UnknownChangeForUnknownElement } from "../timeline"
import { divergeTimeline, generateElementChange } from "../timeline/transactions"

export const designateEdge: TransactionOperation<
  string,
  UnknownChangeForUnknownElement[]
> = (transactors, edgeId) => {
  const { get, set } = transactors
  const edge = get(findEdgeState(edgeId))
  const { edgeType: previousEdgeType } = edge
  const edgeType = get(edgeDesignationState)
  // const setback = get(designLocalState).setbacks[edgeType]

  set(findEdgeState(edgeId), (current) => ({ ...current, edgeType }))
  const undoEdgeUpdate: EdgeActionTo_[`UPDATE`] = {
    type: `UPDATE`,
    family: `EDGE`,
    id: edgeId,
    payload: { edgeType: previousEdgeType },
  }
  const edgeDesignation = generateElementChange(transactors, {
    from: `undo`,
    action: undoEdgeUpdate,
  })
  if (![`eave`, `ridge`].includes(edgeType)) {
    return [edgeDesignation]
  }
  const areaIds = getAreaIdsOfEdge(transactors, edge)

  const areaReorientations = areaIds.map((areaId) =>
    findAzimuth(transactors, {
      areaId,
      edgeId,
      edgeType,
    }),
  )

  return [edgeDesignation, ...areaReorientations]
}

export const designateOneEdge: TransactionOperation<string> = (
  transactors,
  edgeId,
) => {
  const change = designateEdge(transactors, edgeId)
  divergeTimeline(transactors, change)
}

export const useDesignateEdge: (id: string) => () => void = (id) =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => designateOneEdge(transactors, id),
  )
